import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = { filterPath: String, turboFrame: String };

  static targets = ['filterButton'];

  connect() {
    this.filterButtonTarget.addEventListener('click', this.openFilterDropdown);
    window.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  openFilterDropdown = () => {
    const wrapper = document.getElementById(this.turboFrameValue);
    const children = wrapper.querySelector('div');

    if (children) {
      if (children.style.display === 'none') {
        children.style.display = 'block';
      } else if (children.dataset.filterAttribute === 'true') {
        children.remove();
      } else {
        children.style.display = 'none';
      }
    } else {
      const url = new URL(this.filterPathValue);
      Turbo.visit(url, { frame: this.turboFrameValue });
    }
  };

  handleKeydown(event) {
    if (event.code === 'Escape') {
      const wrapper = document.getElementById(this.turboFrameValue);
      const children = wrapper.querySelector('div');

      if (children && children.style.display === 'block') {
        children.style.display = 'none';
      }
    }
  }
}
